import React from "react"
import { Box } from "@mui/material"
import { LoadingIconSeeker } from "@ui-seeker/core"


export default function AppButtonLoading({ ...props }) {
    return <Box className="is-loading" sx={{  display: 'flex', justifyContent: 'center'  }}>
		<LoadingIconSeeker { ...props } />
	</Box>
}